'use strict';

var
  Backbone = require('backbone'),
  config = require('../../js/config'),
  projectModel = require('./projectModel'),

  ProjectsCollection = Backbone.Collection.extend({

    model: projectModel,
    url: config.urls.projects.api,

    // Sort by date from the newest
    comparator: function(model) {
      var date = new Date(model.get('dateModified'));
      return -date;
    }

  });

module.exports = ProjectsCollection;



// WEBPACK FOOTER //
// ./assets/components/DesignCenter/projectsCollection.js